/************************************************************
 * Project: Book App
 * Author: Marcos Santos - A01072792
 * BCIT class Comp2913 - ReactJS by Daniel Takeuchi
 * Date: October, 10, 2020.
 * Description: Assignment - Book App
 * https://github.com/maasantos10/
 ************************************************************/

import styled from 'styled-components';

import { shade } from 'polished';

export const Container = styled.button`
  background: #0275AA;
  height: 56px;
  border-radius: 10px;
  border: 0px;
  padding: 0 16px;
  color: #312e38;
  width: 100%;
  font-weight: 500;
  margin-top: 16px;
  transition: background-color 0.2s;

  &:hover {
    background: ${shade(0.2, '#0275AA')};
  }
`;
